import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import store from "@/store/index";

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: localStorage.getItem("proof") ? routes : [],
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("proof")) {
    next();
  } else {
    router.addRoutes(routes);
    localStorage.setItem("proof", "--");
    next({ ...to, replace: true });
  }
});

router.afterEach((to, from) => {
  if (to.meta && to.meta.keepAlive === true) {
    store.commit("ADD_KA_ROUTES", to.meta.name);
  }
});

export default router;
